import store from '@/store';
import axios from 'axios';
import ApiError from '@/classes/v2/ApiError';
import { STATUS_CODE } from '@/constants/httpStatusCodes';

export default class BaseService {
  static $http = axios;
  static apiDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

  static getRequest(URI, config = {}) {
    return this.$http
      .get(URI, config)
      .then(this.extractPayload)
      .catch(this.errorHandler);
  }

  static postRequest(URI, data, config = {}) {
    return this.$http
      .post(URI, data, config)
      .then(this.extractPayload)
      .catch(this.errorHandler);
  }

  static postRequestForData(URI, data, config = {}) {
    return this.$http.post(URI, data, config).then(this.extractData).catch(this.errorHandler);
  }

  static deleteRequest(URI, config = {}) {
    return this.$http
      .delete(URI, config)
      .then(this.extractPayload)
      .catch(this.errorHandler);
  }

  static deleteRequestWithFullResponse(URI, config = {}) {
    return this.$http
      .delete(URI, config)
      .then(this.extractFullResponse)
      .catch(this.errorHandler);
  }

  static extractPayload({ data, status }) {
    if (status === STATUS_CODE.ok) {
      return data.payload;
    } else {
      return Promise.reject(`${status} Unhandled scenario.`);
    }
  }

  static extractFullResponse({ data }) {
      return data;
  }

  static extractData({ headers, data, status }) {
    if (status === STATUS_CODE.ok) {
      const mimeType = headers['content-type'];
      return { data, mimeType };
    } else {
      return Promise.reject(`${status} Error retrieving data`);
    }
  }

  static errorHandler(error) {
    if (axios.isCancel(error)) {
      console.log('Request canceled:', error.message);
    } else if (error.isAxiosError) {
      if (error.response.status === STATUS_CODE.unauthorized) {
        store?.dispatch('user/unregisterUser');
        sessionStorage.clear();
      }

      throw new ApiError({
        statusCode: error.response.status,
        axiosMessage: error.message,
        serverMessage: error.response.data.responseMessage
      });
    } else {
      console.log(error);
    }
  }

  static onApiError(apiError) {
    console.table({
      'Status code': apiError.statusCode,
      'Axios message': apiError.axiosMessage,
      'Server message': apiError.serverMessage
    });
  }

  static get currentUser() {
    return store?.getters['user/currentUser'];
  }

  static get currentUserId() {
    return store?.getters['user/getUserId'];
  }

  static get encodedUserNumber() {
    return encodeURIComponent(this.currentUser?.number);
  }

  static get encodedUserId() {
    return encodeURIComponent(this.currentUser?.userId);
  }

  static get encodedEnterpriseId() {
    return encodeURIComponent(this.currentUser?.enterpriseId);
  }
}
